import { Grid, Stack, Typography } from "@mui/material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import { useTheme } from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";

export default observer(function CopyUrlButton(props: {id: number}) {
    const {themeClass} = useTheme();
    const [text, setText] = useState("general.copyUrl.copy");
    const copyUrl = useCallback(() => {
        var url = window.location.href;
        if (!url.includes("?guid=")) url += `?guid=${props.id}`;
        navigator.clipboard.writeText(url);
        setText("general.copyUrl.copied");
    }, [props.id])
    
    return (
        <Grid container xs={12} sm={12} className='centered'>
            
            <Stack>
                <Button
                    id={"copy-url"}
                    className={themeClass(["btn-big"])}
                    textKey={text}
                    onClick={copyUrl}
                />
                <Typography color="red">{translationService.translate("general.expiration.warning")}</Typography>
            </Stack>
        </Grid>
    )
})